import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const fetchNftData = async () => {
  const url = `${backendUrl}/api/users/subscription-data/`;
  
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении NFT данных');
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при отправке GET запроса на /api/users/subscription-data/:', error);
    throw error;
  }
};